import type { ReviewRow } from "@/components/ui/transaction-review-contract";

/*
 * THE REVIEW AS THE HOLDER READS IT. The row builders (`features/wallet/
 * review-rows`) document every figure for us — which endpoint does not publish
 * a fee, why no quote can expire, what the server does not re-check. That is
 * the engineering record, and the legacy face still prints it; the v2 money
 * surfaces show the holder only what they can act on:
 *   · rows that can never hold a figure (platform fee, gas, quote expiry,
 *     slippage, minimum, idempotency, server validation…) are left out;
 *   · a figure keeps one plain sentence where it matters (an estimate says it
 *     is one; a total says a network fee may be added) and no other note;
 *   · a figure not known yet is a dash, without the internal reason.
 * The figures themselves are untouched.
 */

const HIDDEN = new Set(["platform-fee", "gas", "atomicity", "backend-validation", "minimum", "quote-expiry", "slippage", "verification", "settlement", "validity", "card-value", "single-use"]);

const PLAIN: Record<string, (fa: boolean) => string> = {
  "total-leaving": (fa) => (fa ? "ممکن است کارمزد شبکه هم از کیف پول کسر شود." : "A network fee may also be deducted."),
  payable: (fa) => (fa ? "تخمینی بر اساس قیمت همین لحظه؛ مبلغ قطعی را درگاه پرداخت نشان می‌دهد." : "Estimated at today's price; the bank gateway shows the final amount."),
  "receive-amount": (fa) => (fa ? "تخمینی بر اساس قیمت همین لحظه؛ مقدار نهایی ممکن است کمی فرق کند." : "Estimated at current prices; the final amount may differ slightly."),
};

export function readerRows(rows: ReviewRow[], lang: "fa" | "en"): ReviewRow[] {
  const fa = lang === "fa";
  return rows
    .filter((r) => !HIDDEN.has(r.id))
    .map((r): ReviewRow => {
      const v = r.value;
      if (v.kind === "pending" || v.kind === "unavailable") return { ...r, value: { kind: "value", text: "—" } };
      const plain = PLAIN[r.id]?.(fa);
      // A swap's rate sits next to its estimated receive amount, which already says so.
      if (v.kind === "estimate" && r.id === "rate") return { ...r, value: { kind: "value", text: v.text, technical: v.technical } };
      if (v.kind === "estimate") return { ...r, value: { kind: "estimate", text: v.text, technical: v.technical, basis: plain ?? (fa ? "تخمینی بر اساس قیمت همین لحظه." : "Estimated at current prices.") } };
      return { ...r, value: { kind: "value", text: v.text, technical: v.technical, note: plain } };
    });
}
